import * as React from 'react';

export default ({size}: {size?: number}) => (
  <svg
    width={size ?? 50}
    height={size ?? 50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="50" rx="25" fill="#FFD600" />
    <path
      d="M17.5002 25H32.9766"
      stroke="white"
      strokeWidth="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
